<template>
  <v-card class="cursosPointer sm-6" :class="{ 'disabled-button': disabled }">
    <v-card-text class="pa-0">
      <v-container class="pa-0">
        <div class="layout row ma-0">
          <div class="flex py-5" :class="fontColor + ' ' + bgcolor">
            <div class="title text-center">{{text}}</div>
          </div>
        </div>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    text: String,
    fontColor: String,
    bgcolor: String,
    disabled: Boolean // Nueva prop para manejar el estado
  },
};
</script>
<style scoped>
/* Estilos cuando está deshabilitado */
.disabled-button {
  opacity: 0.5;  /* Hace que parezca desactivado */
  pointer-events: none; /* Evita clics */
  filter: grayscale(100%); /* Lo pone en escala de grises */
}
</style>